var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    staticClass: "info-data",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "配方名字",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入配方名字..."
    },
    model: {
      value: _vm.formItem.name,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "name", $$v);
      },
      expression: "formItem.name"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "含固量（%）(例：45%则填45）",
      "prop": "solidContent"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 100,
      "step": 1,
      "placeholder": "45%则填45"
    },
    model: {
      value: _vm.formItem.solidContent,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "solidContent", $$v);
      },
      expression: "formItem.solidContent"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "A料滴加时间（秒）",
      "prop": "dijiaATime"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "step": 1,
      "placeholder": "输入A料滴加时间..."
    },
    model: {
      value: _vm.formItem.dijiaATime,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "dijiaATime", $$v);
      },
      expression: "formItem.dijiaATime"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "B料滴加时间（秒）",
      "prop": "dijiaBTime"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "step": 1,
      "placeholder": "输入B料滴加时间..."
    },
    model: {
      value: _vm.formItem.dijiaBTime,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "dijiaBTime", $$v);
      },
      expression: "formItem.dijiaBTime"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "C料滴加时间（秒）",
      "prop": "dijiaCTime"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "step": 1,
      "placeholder": "输入C料滴加时间..."
    },
    model: {
      value: _vm.formItem.dijiaCTime,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "dijiaCTime", $$v);
      },
      expression: "formItem.dijiaCTime"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "保温时间（秒）",
      "prop": "baowenTime"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "step": 1,
      "placeholder": "输入保温时间..."
    },
    model: {
      value: _vm.formItem.baowenTime,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "baowenTime", $$v);
      },
      expression: "formItem.baowenTime"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "中和时间（秒）",
      "prop": "zhongheTime"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "step": 1,
      "placeholder": "输入中和时间..."
    },
    model: {
      value: _vm.formItem.zhongheTime,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "zhongheTime", $$v);
      },
      expression: "formItem.zhongheTime"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入备注...",
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      }
    },
    model: {
      value: _vm.formItem.remark,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "remark", $$v);
      },
      expression: "formItem.remark"
    }
  })], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")]), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('closeDrawer');
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _c('div', {
    staticClass: "table-panel"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.displayData,
      "border": "",
      "show-summary": "",
      "summary-method": _vm.handleSummary
    },
    scopedSlots: _vm._u([{
      key: "ratio",
      fn: function (_ref) {
        var row = _ref.row,
          index = _ref.index;
        return [row.name !== '水' ? _c('div', [_c('InputNumber', {
          staticClass: "input-ratio",
          attrs: {
            "max": 100,
            "min": 0,
            "step": 0.1
          },
          model: {
            value: _vm.recipeDetailList[index].ratio,
            callback: function ($$v) {
              _vm.$set(_vm.recipeDetailList[index], "ratio", $$v);
            },
            expression: "recipeDetailList[index].ratio"
          }
        }), _c('span', {
          staticClass: "percentage-append"
        }, [_vm._v("%")])], 1) : _c('span', [_vm._v(_vm._s(row.ratio) + "%")])];
      }
    }, {
      key: "deleteBtn",
      fn: function (_ref2) {
        var row = _ref2.row;
        return [row.name !== '水' ? _c('Icon', {
          staticClass: "deleteBtn",
          attrs: {
            "type": "ios-remove-circle-outline",
            "size": "18"
          },
          on: {
            "click": function ($event) {
              return _vm.removeMaterialfromRecipe(row._id);
            }
          }
        }) : _vm._e()];
      }
    }])
  })], 1), _c('div', {
    staticClass: "material-list-block"
  }, [_c('Input', {
    staticStyle: {
      "margin": "0 4px"
    },
    attrs: {
      "search": "",
      "clearable": "",
      "placeholder": "搜索原材料..."
    },
    on: {
      "on-search": _vm.searchMaterial
    },
    model: {
      value: _vm.searchMaterialText,
      callback: function ($$v) {
        _vm.searchMaterialText = $$v;
      },
      expression: "searchMaterialText"
    }
  }), _c('Divider', {
    attrs: {
      "orientation": "left"
    }
  }, [_vm._v("原材料")]), _c('div', {
    staticClass: "material-list"
  }, _vm._l(_vm.materialList.filter(function (x) {
    return x.type === 'raw' && x.usedForSemi === true;
  }), function (i) {
    return _c('div', {
      key: i._id,
      class: {
        'm-cell': true,
        selected: _vm.displayData.map(function (e) {
          return e._id;
        }).indexOf(i._id) !== -1
      },
      on: {
        "click": function ($event) {
          return _vm.selectMaterial(i);
        }
      }
    }, [_vm._v(" " + _vm._s(i.name) + " ")]);
  }), 0)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }